import { render, staticRenderFns } from "./entry.block.pug?vue&type=template&id=19c8cb44&scoped=true&lang=pug&external"
import script from "./entry.block.ts?vue&type=script&lang=ts&external"
export * from "./entry.block.ts?vue&type=script&lang=ts&external"
import style0 from "./entry.block.sass?vue&type=style&index=0&id=19c8cb44&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c8cb44",
  null
  
)

export default component.exports